var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingUtglNative = function SvgSettingUtglNative(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Setting_UTGL_Native_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.02 8.684a4.329 4.329 0 0 1-4.19-3.246L.25 5.352V3.297h2.459C3.367 1.295 5.064 0 7.02 0a4.332 4.332 0 0 1 4.19 3.211l13.039.086v2.055H11.332c-.658 2.037-2.355 3.332-4.311 3.332Zm0-6.716c-1.28 0-2.285 1.019-2.285 2.314 0 1.294 1.004 2.313 2.286 2.313 1.28 0 2.285-1.019 2.285-2.313 0-1.295-1.004-2.314-2.285-2.314Z",
    fill: "#305992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.666 17.316a4.329 4.329 0 0 1-4.19-3.246L.284 13.984V11.93H12.37c.658-2.003 2.372-3.332 4.312-3.332 1.94 0 3.654 1.329 4.156 3.245l3.376.087v2.054H20.96c-.623 2.003-2.32 3.332-4.277 3.332h-.017Zm0-6.716c-1.282 0-2.286 1.019-2.286 2.314 0 1.295 1.004 2.313 2.286 2.313 1.281 0 2.199-.984 2.233-2.227 0-1.381-1.004-2.383-2.233-2.383V10.6Z",
    fill: "#CC8528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.276 26a4.329 4.329 0 0 1-4.19-3.246L.25 22.668v-2.055h1.732c.658-2.002 2.372-3.331 4.311-3.331a4.36 4.36 0 0 1 4.19 3.245l13.732.086v2.055H10.588C9.93 24.671 8.215 26 6.276 26Zm0-6.681a2.28 2.28 0 0 0-2.286 2.279c.035 1.294 1.057 2.313 2.286 2.313 1.23 0 2.234-.984 2.286-2.227-.035-1.33-1.057-2.348-2.286-2.348v-.017Z",
    fill: "#305992"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Setting_UTGL_Native_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.25)",
    d: "M0 0h24v26H0z"
  })))));
};
export default SvgSettingUtglNative;